const RUNTIME_SHIM_SPECIFIER_PATTERN = /^\/__mutiny\/runtime\/([\w-]+)\/([\w.-]+)\.js$/;

// The compiler only emits registry-allowlisted slugs and versions, so this remains a pure path
// transform. An unknown but well-formed slug will fail when the matching asset returns 404.
export function buildRuntimeShimPath(specifier: string): string {
  const match = specifier.match(RUNTIME_SHIM_SPECIFIER_PATTERN);
  if (!match) {
    throw new Error(`Unsupported custom-component runtime specifier: ${specifier}`);
  }
  const [, slug, version] = match;
  return `/assets/mutiny-runtime-${slug}-${version}.js`;
}

export function buildRuntimeShimUrl(staticAssetsBaseURL: string | null, specifier: string): string {
  return `https://${staticAssetsBaseURL}${buildRuntimeShimPath(specifier)}`;
}
